import { useRef } from "react";
import { useScroll } from "framer-motion";
import Card from "./Cards/Cards";

import { useTranslation } from "react-i18next";



export default function ProjectsSection() {

    const container = useRef(null);

    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start start", "end end"],
    });

    const { t } = useTranslation();

    const cards = t("experience-cards.items", {
        returnObjects: true,
    });

    return (

        
    
        <section
            ref={container}
            className="projects-section"
        >

            <div className="projects-wrapper">

                {cards.map((project, index) => (

                    <Card
                        key={index}
                        project={project}
                        index={index}
                        total={cards.length}
                        progress={scrollYProgress}
                    />

                ))}

            </div>
        </section>
    );
}